import { testConnectorConfigVccLiveDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const testConnectorConfigVccLiveCallable = getCallable(
  testConnectorConfigVccLiveDefinition,
);
